import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import { GlobalStyles, StyledEngineProvider } from '@mui/material';

import { Config } from 'config';
import { ErrorBoundary } from 'components';

import App from './App';

const { sentry } = Config;
const isProductionTelemetry = sentry.env === 'production';

if (sentry.dsn) {
  if (sentry.release) {
    console.log(`VERSION ${sentry.release}`);
  }
  try {
    Sentry.init({
      dsn: sentry.dsn,
      enableLogs: true,
      environment: sentry.env,
      release: sentry.release,
      tracesSampleRate: isProductionTelemetry ? 0 : 1.0,
      replaysSessionSampleRate: isProductionTelemetry ? 0 : 0.1,
      replaysOnErrorSampleRate: isProductionTelemetry ? 0 : 1.0,
      ignoreErrors: [
        'AxiosError',
        'TimeoutError',
        'Loading chunk',
        "Unexpected token '<'",
        'Failed to fetch dynamically',
      ],
      integrations: isProductionTelemetry
        ? []
        : [
            Sentry.replayIntegration(),
            Sentry.browserTracingIntegration(),
            Sentry.consoleLoggingIntegration(),
          ],
    });
    Sentry.setUser(null);
  } catch (error) {
    console.error(error);
  }
}

if (Config.waf.apiUrl) {
  const AwsWafScript = document.createElement('script');
  AwsWafScript.id = 'AwsWAFScript';
  AwsWafScript.async = false;
  AwsWafScript.src = Config.waf.apiUrl;
  document.head.appendChild(AwsWafScript);
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StyledEngineProvider enableCssLayer>
    <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StyledEngineProvider>
);
